module.exports = __webpack_public_path__ + "static/vampire_spawn-adbb6d7b8900ce33ff38f13dd2717b88.jpeg";